module.exports = __webpack_public_path__ + "static/media/grayBillPayment.5ca0b2e0.svg";